import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryTabs = ({ activeCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', label: 'All Stories', icon: 'Grid3x3', count: 127 },
    { id: 'striker', label: 'Strikers', icon: 'Target', count: 34 },
    { id: 'midfielder', label: 'Midfielders', icon: 'Zap', count: 42 },
    { id: 'defender', label: 'Defenders', icon: 'Shield', count: 28 },
    { id: 'goalkeeper', label: 'Goalkeepers', icon: 'Hand', count: 15 },
    { id: 'coach', label: 'Coaches', icon: 'Clipboard', count: 8 }
  ];

  return (
    <div className="mb-6 md:mb-8">
      <div className="flex overflow-x-auto gap-2 pb-2 scrollbar-hide">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`flex-shrink-0 flex items-center gap-2 px-4 py-3 rounded-lg font-medium transition-all duration-300 ${
              activeCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-md'
                : 'bg-card text-foreground hover:bg-muted'
            }`}
          >
            <Icon
              name={category?.icon}
              size={18}
              color={activeCategory === category?.id ? 'var(--color-primary-foreground)' : 'currentColor'}
            />
            <span className="text-sm md:text-base whitespace-nowrap">
              {category?.label}
            </span>
            <span
              className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                activeCategory === category?.id
                  ? 'bg-primary-foreground/20 text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              {category?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryTabs;